export default __webpack_public_path__ + "static/media/roles_7.eae4a4ff.png";